module.exports = __webpack_public_path__ + "img/img1.619a5d25.png";